import React, { Fragment, useEffect, useRef, useState } from "react";

import {
  Autocomplete,
  Backdrop,
  Box,
  createTheme,
  CssBaseline,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Skeleton,
  TextField,
  ThemeProvider,
} from "@mui/material";
import Loader from "../../../components/Loader";
import { toast, ToastContainer } from "react-toastify";
import { common_axios } from "../../../App";
import { useFormik } from "formik";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

export default function TransferList() {
  const [open, setOpen] = React.useState(false);
  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState([]);
  const [right, setRight] = React.useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [roles, setRoles] = useState(null);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  //   useEffect(() => {
  //     if (roles) {
  //       const filterRole = rolesList.filter((el) => {
  //         return roles.name == el.name;
  //       });
  //       console.log(filterRole, filterRole.menuDetails);

  //       setLeft(filterRole[0].menuDetails);
  //       //   setReset(filterRole[0].menuDetails);
  //       // setLeft(roles1[0]?.menuDetails);
  //       // setReset(roles1[0]?.menuDetails);
  //     }
  //   }, [roles]);

  const getRoles = async () => {
    try {
      setOpen(true);
      const res = await common_axios(`admin/v1/roles/list?roleId=1`);
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setRolesList(res.data.role.menuDetails);
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      await toast.error("Something went wrong !! Please check your network", {
        theme: "colored",
      });
    }
  };

  React.useEffect(async () => {
    await getRoles();
    // await fetchApi();
  }, []);

  const customList = (title, items) => (
    <Card>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{
              "aria-label": "all items selected",
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />
      <Divider />
      <List
        sx={{
          width: 200,
          height: 230,
          bgcolor: "background.paper",
          overflow: "auto",
        }}
        dense
        component="div"
        role="list"
      >
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <Fragment key={value.id}>
              <label>{value.name}</label>
              {value?.subMenuDetails?.map((list) => {
                return (
                  <ListItem
                    key={list.id}
                    role="listitem"
                    button
                    onClick={handleToggle(list)}
                  >
                    <ListItemIcon>
                      <Checkbox
                        checked={checked.indexOf(list) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText id={labelId} primary={list?.subMenu} />
                  </ListItem>
                );
              })}
            </Fragment>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );

  return (
    <>
      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
      >
        <Loader />
      </Backdrop>
      <ToastContainer autoClose={6000} />
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item>{customList("Choices", left)}</Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
          </Grid>
        </Grid>
        <Grid item>{customList("Chosen", right)}</Grid>
      </Grid>
    </>
  );
}
